<template>
  <section>
    <hero-bar>Update List</hero-bar>
    <div class="w-full p-6 mt-16-mob">
      <div class="flex items-center w-full border font-bold p-4">
        <div class="flex items-center w-max h-8 cursor-pointer" @click="onBack">
          <base-icon size="32" h="h-16" w="" :path="mdiArrowLeftThin" /> Back To Project
        </div>
      </div>
    </div>
    <main-section>
      <card-component class="mb-6 select-none" title="Details">
        {{ AllCollectionUserProject }}
        <div class="overflow-auto h-[31rem] scrol-list">
          <div class="grid grid-cols-2 lg:grid-cols-12 gap-4 border-b-2 py-6 w-break" v-for="(item, index) in storeVar.data"
            :key="index">
            <label class="font-semibold text-xs text-blue-400 unselectable">Serial No </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.serialNo }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Title </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.title }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> First Name
            </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.firstName }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Last Name </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] break-all unselectable lg:col-span-2">
              :&nbsp;&nbsp; {{
                item.lastName }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Initial
            </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.initial }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Email </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.email }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Father Name </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.fatherName }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> DOB </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.dob }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Gender
            </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.gender }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Profession
            </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.profession }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Mailing Street </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.mailingStreet }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Mailing City
            </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.mailingCity }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Mailing Postal Code
            </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.mailingPostalCode }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Mailing Country </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.mailingCountry }}
            </label>

            <label class="font-semibold text-xs text-blue-400 unselectable"> Service Provider </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.serviceProvider }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> File No </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.fileNo }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Reference No </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.referenceNo }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Sim No </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.simNo }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Type Of Network </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.typeOfNetwork }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Cell Model No </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.cellModelNo }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> IMEI 1 </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.imei1 }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> IMEI 2 </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.imei2 }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Type Of Plan </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.typeOfPlan }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Credit Card Type </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.creditCardType }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Contract Value </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.contractValue }}
            </label>

            <label class="font-semibold text-xs text-blue-400 unselectable"> Date Of Issue </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.dateOfIssue }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Date Of Renewal </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.dateOfRenewal }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Installment </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.installment }}
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Amount In Words </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              <!-- {{ item.amountInWords }} -->
            </label>
            <label class="font-semibold text-xs text-blue-400 unselectable"> Remarks </label>
            <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable lg:col-span-2"> :&nbsp;&nbsp;
              {{
                item.remarks }}
            </label>
            <!-- <base-divider /> -->
          </div>
        </div>
      </card-component>
    </main-section>

    <main-section>
      <card-component class="mb-6" :title="'File (' + storeVar.imageName + ')'">
        <div class="details-edit-tables" v-for="(item, index) in storeVar.fillData"
          :key="index">
          <base-field label="Serial No" :help="formVar.submit ? serialNoValid : ''">
            <base-control type="text" class="dd" v-model="item.serialNo" placeholder="Enter Serial No" @keypress="isNumber($event)"
              @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil"
              :ind="index" :icon2="mdiCloseThick" :disabled="item.serialNodisable"
              @update:changeDate="onDateChange($event, `serialNo`, index)" />

          </base-field>
          <base-field label="Title" :help="formVar.submit ? titleValid : ''">
            <base-control v-model="item.title" type="text" placeholder="Enter Title" @keydown="disableTab($event)"
              @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil" :icon2="mdiCloseThick"
              :disabled="item.titledisable" @update:changeDate="onDateChange($event, 'title', index)" />
          </base-field>
          <base-field label="First Name" :help="formVar.submit ? firstNameValid : ''">
            <base-control v-model="item.firstName" type="text" placeholder="Enter First Name"
              @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil"
              :icon2="mdiCloseThick" :disabled="item.firstNamedisable"
              @update:changeDate="onDateChange($event, 'firstName', index)" />
          </base-field>
          <base-field label="Last Name" :help="formVar.submit ? lastNameValid : ''">
            <base-control v-model="item.lastName" type="text" placeholder="Enter Last Name" @keydown="disableTab($event)"
              @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil" :icon2="mdiCloseThick"
              :disabled="item.lastNamedisable" @update:changeDate="onDateChange($event, 'lastName', index)" />
          </base-field>
          <base-field label="Initial" :help="formVar.submit ? initialValid : ''">
            <base-control v-model="item.initial" type="text" placeholder="Enter Initial" @keydown="disableTab($event)"
              @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil" :icon2="mdiCloseThick"
              :disabled="item.initialdisable" @update:changeDate="onDateChange($event, 'initial', index)" />
          </base-field>
          <base-field label="Email" :help="formVar.submit ? emailValid : ''">
            <base-control v-model="item.email" type="text" placeholder="Enter Email" @keydown="disableTab($event)"
              @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil" :icon2="mdiCloseThick"
              :disabled="item.emaildisable" @update:changeDate="onDateChange($event, 'email', index)" />
          </base-field>
          <base-field label="Father Name" :help="formVar.submit ? fatherNameValid : ''">
            <base-control v-model="item.fatherName" type="text" placeholder="Enter Father Name"
              @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil"
              :icon2="mdiCloseThick" :disabled="item.fatherNamedisable"
              @update:changeDate="onDateChange($event, 'fatherName', index)" />
          </base-field>
          <base-field label="Dob" :help="formVar.submit ? dobValid : ''">
            <base-control v-model="item.dob" type="text" placeholder="yyyy-mm-dd" @keypress="isNumberWithHighpen($event)"
              @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil"
              :icon2="mdiCloseThick" :disabled="item.dobdisable" @update:changeDate="onDateChange($event, 'dob', index)" />



          </base-field>
          <base-field label="Gender" :help="formVar.submit ? genderValid : ''">
            <base-control v-model="item.gender" type="text" placeholder="Enter Gender" @keydown="disableTab($event)"
              @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil" :icon2="mdiCloseThick"
              :disabled="item.genderdisable" @update:changeDate="onDateChange($event, 'gender', index)" />
          </base-field>
          <base-field label="Profession" :help="formVar.submit ? professionValid : ''">
            <base-control v-model="item.profession" type="text" placeholder="Enter Profession"
              @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil"
              :icon2="mdiCloseThick" :disabled="item.professiondisable"
              @update:changeDate="onDateChange($event, 'profession', index)" />
          </base-field>
          <base-field label="Mailing Street" :help="formVar.submit ? mailingStreetValid : ''">
            <base-control v-model="item.mailingStreet" type="text" placeholder="Enter Mailing Street"
              @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil"
              :icon2="mdiCloseThick" :disabled="item.mailingStreetdisable"
              @update:changeDate="onDateChange($event, 'mailingStreet', index)" />
          </base-field>
          <base-field label="Mailing City" :help="formVar.submit ? mailingCityValid : ''">
            <base-control v-model="item.mailingCity" type="text" placeholder="Enter Mailing City"
              @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil"
              :icon2="mdiCloseThick" :disabled="item.mailingCitydisable"
              @update:changeDate="onDateChange($event, 'mailingCity', index)" />
          </base-field>
          <base-field label="Mailing Postal Code" :help="formVar.submit ? mailingPostalCodeValid : ''">
            <base-control v-model="item.mailingPostalCode" type="text" placeholder="Enter Mailing Postal Code"
              @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil"
              :icon2="mdiCloseThick" :disabled="item.mailingPostalCodedisable"
              @update:changeDate="onDateChange($event, 'mailingPostalCode', index)" />
          </base-field>
          <base-field label="Mailing Country" :help="formVar.submit ? mailingCountryValid : ''">
            <base-control v-model="item.mailingCountry" type="text" placeholder="Enter Mailing Country"
              @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil"
              :icon2="mdiCloseThick" :disabled="item.mailingCountrydisable"
              @update:changeDate="onDateChange($event, 'mailingCountry', index)" />
          </base-field>
          <base-field label="Service Provider" :help="formVar.submit ? serviceProviderValid : ''">
            <base-control v-model="item.serviceProvider" type="text" placeholder="Enter Service Provider"
              @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil"
              :icon2="mdiCloseThick" :disabled="item.serviceProviderdisable"
              @update:changeDate="onDateChange($event, 'serviceProvider', index)" />
          </base-field>
          <base-field label="File No" :help="formVar.submit ? fileNoValid : ''">
            <base-control v-model="item.fileNo" type="text" placeholder="Enter File No" @keypress="isNumber($event)"
              @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil"
              :icon2="mdiCloseThick" :disabled="item.fileNodisable"
              @update:changeDate="onDateChange($event, 'fileNo', index)" />
          </base-field>
          <base-field label="Reference No" :help="formVar.submit ? referenceNoValid : ''">
            <base-control v-model="item.referenceNo" type="text" placeholder="Enter Reference No"
              @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil"
              :icon2="mdiCloseThick" :disabled="item.referenceNodisable"
              @update:changeDate="onDateChange($event, 'referenceNo', index)" @keypress="isNumberAndSpecial($event)" />
          </base-field>
          <base-field label="Sim No" :help="formVar.submit ? simNoValid : ''">
            <base-control v-model="item.simNo" type="text" placeholder="Enter Sim No" @keypress="isNumber($event)"
              @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil"
              :icon2="mdiCloseThick" :disabled="item.simNodisable"
              @update:changeDate="onDateChange($event, 'simNo', index)" />
          </base-field>
          <base-field label="Type Of Network" :help="formVar.submit ? typeOfNetworkValid : ''">
            <base-control v-model="item.typeOfNetwork" type="text" placeholder="Enter Type Of Network"
              @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil"
              :icon2="mdiCloseThick" :disabled="item.typeOfNetworkdisable"
              @update:changeDate="onDateChange($event, 'typeOfNetwork', index)" />
          </base-field>
          <base-field label="Cell Model No" :help="formVar.submit ? cellModelNoValid : ''">
            <base-control v-model="item.cellModelNo" type="text" placeholder="Enter Cell Model No"
              @keypress="isNumber($event)" @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart"
              autocomplete="off" :icon="mdiPencil" :icon2="mdiCloseThick" :disabled="item.cellModelNodisable"
              @update:changeDate="onDateChange($event, 'cellModelNo', index)" />
          </base-field>
          <base-field label="IMEI 1" :help="formVar.submit ? imei1Valid : ''">
            <base-control v-model="item.imei1" type="text" placeholder="Enter EMEI 1" @keydown="disableTab($event)"
              @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil" :icon2="mdiCloseThick"
              :disabled="item.imei1disable" @update:changeDate="onDateChange($event, 'imei1', index)" />
          </base-field>
          <base-field label="IMEI 2" :help="formVar.submit ? imei2Valid : ''">
            <base-control v-model="item.imei2" type="text" placeholder="Enter EMEI 2" @keydown="disableTab($event)"
              @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil" :icon2="mdiCloseThick"
              :disabled="item.imei2disable" @update:changeDate="onDateChange($event, 'imei2', index)"
              @keypress="isNumberAndSpecial($event)" />
          </base-field>
          <base-field label="Type Of Plan" :help="formVar.submit ? typeOfPlanValid : ''">
            <base-control v-model="item.typeOfPlan" type="text" placeholder="Enter Type Of Plan"
              @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil"
              :icon2="mdiCloseThick" :disabled="item.typeOfPlandisable"
              @update:changeDate="onDateChange($event, 'typeOfPlan', index)" />
          </base-field>
          <base-field label="Credit Card Type" :help="formVar.submit ? creditCardTypeValid : ''">
            <base-control v-model="item.creditCardType" type="text" placeholder="Enter Credit Card Type"
              @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil"
              :icon2="mdiCloseThick" :disabled="item.creditCardTypedisable"
              @update:changeDate="onDateChange($event, 'creditCardType', index)" />
          </base-field>
          <base-field label="Contract Value" :help="formVar.submit ? contractValueValid : ''">
            <base-control v-model="item.contractValue" type="text" placeholder="Enter Contract Value"
              @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil"
              :icon2="mdiCloseThick" :disabled="item.contractValuedisable"
              @update:changeDate="onDateChange($event, 'contractValue', index)" />
          </base-field>
          <base-field label="Date Of Issue" :help="formVar.submit ? dateOfIssueValid : ''">
            <base-control v-model="item.dateOfIssue" type="text" placeholder="yyyy-mm-dd"
              @keypress="isNumberWithHighpen($event)" @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart"
              autocomplete="off" :icon="mdiPencil" :icon2="mdiCloseThick" :disabled="item.dateOfIssuedisable"
              @update:changeDate="onDateChange($event, 'dateOfIssue', index)" />
          </base-field>
          <base-field label="Date Of Renewal" :help="formVar.submit ? dateOfRenewalValid : ''">
            <base-control v-model="item.dateOfRenewal" type="text" placeholder="yyyy-mm-dd"
              @keypress="isNumberWithHighpen($event)" @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart"
              autocomplete="off" :icon="mdiPencil" :icon2="mdiCloseThick" :disabled="item.dateOfRenewaldisable"
              @update:changeDate="onDateChange($event, 'dateOfRenewal', index)" />

          </base-field>
          <base-field label="Installment" :help="formVar.submit ? installmentValid : ''">
            <base-control v-model="item.installment" type="text" placeholder="Enter Installment"
              @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil"
              :icon2="mdiCloseThick" :disabled="item.installmentdisable"
              @update:changeDate="onDateChange($event, 'installment', index)" />
          </base-field>
          <base-field label="Amount In Words" :help="formVar.submit ? amountInWordsValid : ''">
            <base-control v-model="item.amountInWords" type="text" placeholder="Enter Amount In Words"
              @keydown="disableTab($event)" @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil"
              :icon2="mdiCloseThick" :disabled="item.amountInWordsdisable"
              @update:changeDate="onDateChange($event, 'amountInWords', index)" />
          </base-field>
          <base-field label="Remarks">
            <base-control v-model="item.remarks" type="text" placeholder="Enter Remarks" @keydown="disableTab($event)"
              @paste="disable" @copy="disable" @drop="onDrop" @dragstart="handleDragStart" autocomplete="off" :icon="mdiPencil" :icon2="mdiCloseThick"
              :disabled="item.remarksdisable" @update:changeDate="onDateChange($event, 'remarks', index)" />
          </base-field>
          <div class="w-full flex justify-center border col-span-5 mt-4">
            <base-buttons class="flex justify-center py-4">
              <base-button type="button" @click="submit(item.id, index)" color="info" label="Submit" effect />
              <base-button type="button" color="indigo" label="Back" effect @click="onBack()" />
            </base-buttons>
          </div>

        </div>

      </card-component>
    </main-section>
  </section>
</template>
  
<script setup>
import {
  mdiPencil,
  // mdiCloseOutline,
  mdiCloseThick,
  mdiArrowLeftThin
} from "@mdi/js";
import { computed, onBeforeMount, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

const store = useStore();
const route = useRoute();
const router = useRouter()
const storeVar = computed(() => store.state.Project);

const formVar = reactive({
  limit: 10, offset: 0, keyword: '',
  formId: null,
  serialNodisable: true,
  titledisable: true,
  firstNamedisable: true,
  lastNamedisable: true,
  initialdisable: true,
  emaildisable: true,
  fatherNamedisable: true,
  dobdisable: true,
  genderdisable: true,
  professiondisable: true,
  mailingStreetdisable: true,
  mailingCitydisable: true,
  mailingPostalCodedisable: true,
  mailingCountrydisable: true,
  serviceProviderdisable: true,
  fileNodisable: true,
  referenceNodisable: true,
  simNodisable: true,
  typeOfNetworkdisable: true,
  cellModelNodisable: true,
  imei1disable: true,
  imei2disable: true,
  typeOfPlandisable: true,
  creditCardTypedisable: true,
  contractValuedisable: true,
  dateOfIssuedisable: true,
  dateOfRenewaldisable: true,
  installmentdisable: true,
  amountInWordsdisable: true,
  remarksdisable: true,
  imageName: null,

});

onBeforeMount(() => {
  if (route.query.id) {
    formVar.formId = route.query.id
    formVar.imageName = route.query.imageName
    getOneProject(formVar.formId)
    getAllCollectionUserProject(formVar.imageName)
    getFillFormList(formVar.imageName)
  }
});
function onDateChange(data, title, index) {
  if (title === 'serialNo') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].serialNo = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].serialNodisable = data.disabled
    }

  } else if (title === 'title') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].title = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].titledisable = data.disabled
    }
  } else if (title === 'firstName') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].firstName = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].firstNamedisable = data.disabled
    }
  } else if (title === 'lastName') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].lastName = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].lastNamedisable = data.disabled
    }
  } else if (title === 'initial') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].initial = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].initialdisable = data.disabled
    }
  } else if (title === 'email') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].email = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].emaildisable = data.disabled
    }
  } else if (title === 'fatherName') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].fatherName = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].fatherNamedisable = data.disabled
    }
  } else if (title === 'dob') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].dob = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].dobdisable = data.disabled
    }
  } else if (title === 'gender') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].gender = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].genderdisable = data.disabled
    }
  } else if (title === 'profession') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].profession = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].professiondisable = data.disabled
    }
  } else if (title === 'mailingStreet') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].mailingStreet = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].mailingStreetdisable = data.disabled
    }
  } else if (title === 'mailingCity') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].mailingCity = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].mailingCitydisable = data.disabled
    }
  } else if (title === 'mailingPostalCode') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].mailingPostalCode = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].mailingPostalCodedisable = data.disabled
    }
  } else if (title === 'mailingCountry') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].mailingCountry = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].mailingCountrydisable = data.disabled
    }
  } else if (title === 'serviceProvider') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].serviceProvider = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].serviceProviderdisable = data.disabled
    }
  } else if (title === 'fileNo') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].fileNo = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].fileNodisable = data.disabled
    }
  } else if (title === 'referenceNo') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].referenceNo = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].referenceNodisable = data.disabled
    }
  } else if (title === 'simNo') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].simNo = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].simNodisable = data.disabled
    }
  } else if (title === 'typeOfNetwork') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].typeOfNetwork = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].typeOfNetworkdisable = data.disabled
    }
  } else if (title === 'cellModelNo') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].cellModelNo = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].cellModelNodisable = data.disabled
    }
  } else if (title === 'imei1') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].imei1 = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].imei1disable = data.disabled
    }
  } else if (title === 'imei2') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].imei2 = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].imei2disable = data.disabled
    }
  } else if (title === 'typeOfPlan') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].typeOfPlan = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].typeOfPlandisable = data.disabled
    }
  } else if (title === 'creditCardType') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].creditCardType = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].creditCardTypedisable = data.disabled
    }
  } else if (title === 'contractValue') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].contractValue = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].contractValuedisable = data.disabled
    }
  } else if (title === 'dateOfIssue') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].dateOfIssue = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].dateOfIssuedisable = data.disabled
    }
  } else if (title === 'dateOfRenewal') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].dateOfRenewal = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].dateOfRenewaldisable = data.disabled
    }
  } else if (title === 'installment') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].installment = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].installmentdisable = data.disabled
    }
  } else if (title === 'amountInWords') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].amountInWords = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].amountInWordsdisable = data.disabled
    }
  } else if (title === 'remarks') {
    if (!data.disabled && data.remove) {
      storeVar.value.fillData[index].remarks = null
    } else if (!data.disabled || data.disabled && !data.remove) {
      storeVar.value.fillData[index].remarksdisable = data.disabled
    }
  }
}

function getOneProject(id) {
  store.dispatch('Project/getOneProject', { id })
}
function getFillFormList(imageName) {
  store.dispatch('Project/getFillFormList', { imageName })
}
function getAllCollectionUserProject(formFileId) {
  store.dispatch('Project/getAllCollectionUserProject', { formFileId })
}
const submit = (id, index) => {
  // if (
  //   serialNoValid.value ||
  //   titleValid.value ||
  //   firstNameValid.value ||
  //   lastNameValid.value ||
  //   initialValid.value ||
  //   emailValid.value ||
  //   fatherNameValid.value ||
  //   dobValid.value ||
  //   genderValid.value ||
  //   professionValid.value ||
  //   mailingStreetValid.value ||
  //   mailingCityValid.value ||
  //   mailingPostalCodeValid.value ||
  //   mailingCountryValid.value ||
  //   serviceProviderValid.value ||
  //   fileNoValid.value ||
  //   referenceNoValid.value ||
  //   simNoValid.value ||
  //   typeOfNetworkValid.value ||
  //   cellModelNoValid.value ||
  //   imei1Valid.value ||
  //   imei2Valid.value ||
  //   typeOfPlanValid.value ||
  //   creditCardTypeValid.value ||
  //   contractValueValid.value ||
  //   dateOfIssueValid.value ||
  //   dateOfRenewalValid.value ||
  //   installmentValid.value ||
  //   amountInWordsValid.value
  // ) {
  //   formVar.submit = true
  //   return;
  // }
  // formVar.submit = false
  store.dispatch('Project/updateProject', { data: storeVar.value.fillData[index] })
  // store.dispatch('Project/updateProject', {
  //   id: storeVar.value.userProjectId,
  //   imageName: storeVar.value.imageName,
  //   serialNo: storeVar.value.serialNo,
  //   title: storeVar.value.title,
  //   firstName: storeVar.value.firstName,
  //   lastName: storeVar.value.lastName,
  //   initial: storeVar.value.initial,
  //   email: storeVar.value.email,
  //   fatherName: storeVar.value.fatherName,
  //   dob: storeVar.value.dob,
  //   gender: storeVar.value.gender,
  //   profession: storeVar.value.profession,
  //   mailingStreet: storeVar.value.mailingStreet,
  //   mailingCity: storeVar.value.mailingCity,
  //   mailingPostalCode: storeVar.value.mailingPostalCode,
  //   mailingCountry: storeVar.value.mailingCountry,
  //   serviceProvider: storeVar.value.serviceProvider,
  //   fileNo: storeVar.value.fileNo,
  //   referenceNo: storeVar.value.referenceNo,
  //   simNo: storeVar.value.simNo,
  //   typeOfNetwork: storeVar.value.typeOfNetwork,
  //   cellModelNo: storeVar.value.cellModelNo,
  //   imei1: storeVar.value.imei1,
  //   imei2: storeVar.value.imei2,
  //   typeOfPlan: storeVar.value.typeOfPlan,
  //   creditCardType: storeVar.value.creditCardType,
  //   contractValue: storeVar.value.contractValue,
  //   dateOfIssue: storeVar.value.dateOfIssue,
  //   dateOfRenewal: storeVar.value.dateOfRenewal,
  //   installment: storeVar.value.installment,
  //   amountInWords: storeVar.value.amountInWords,
  //   remarks: storeVar.value.remarks,
  //   formFileId: storeVar.value.formFileId,
  // })
}
const serialNoValid = computed(() => {
  if (!storeVar.value.serialNo) {
    return 'Enter Serial No'
  } else {
    return null
  }
})
const titleValid = computed(() => {
  if (!storeVar.value.title) {
    return 'Enter Title'
  } else {
    return null
  }
})
const firstNameValid = computed(() => {
  if (!storeVar.value.firstName) {
    return 'Enter First Name'
  } else {
    return null
  }
})
const lastNameValid = computed(() => {
  if (!storeVar.value.lastName) {
    return 'Enter Last Name'
  } else {
    return null
  }
})
const initialValid = computed(() => {
  if (!storeVar.value.initial) {
    return 'Enter Initial'
  } else {
    return null
  }
})
const emailValid = computed(() => {
  if (!storeVar.value.email) {
    return 'Enter Email'
  } else {
    return null
  }
})
const fatherNameValid = computed(() => {
  if (!storeVar.value.fatherName) {
    return 'Enter Father Name'
  } else {
    return null
  }
})
const dobValid = computed(() => {
  if (!storeVar.value.dob) {
    return 'Enter Dob'
  } else {
    return null
  }
})
const genderValid = computed(() => {
  if (!storeVar.value.gender) {
    return 'Enter Gender'
  } else {
    return null
  }
})
const professionValid = computed(() => {
  if (!storeVar.value.profession) {
    return 'Enter Profession'
  } else {
    return null
  }
})
const mailingStreetValid = computed(() => {
  if (!storeVar.value.mailingStreet) {
    return 'Enter Mailing Street'
  } else {
    return null
  }
})
const mailingCityValid = computed(() => {
  if (!storeVar.value.mailingCity) {
    return 'Enter Mailing City'
  } else {
    return null
  }
})
const mailingPostalCodeValid = computed(() => {
  if (!storeVar.value.mailingPostalCode) {
    return 'Enter Mailing Postal Code'
  } else {
    return null
  }
})
const mailingCountryValid = computed(() => {
  if (!storeVar.value.mailingCountry) {
    return 'Enter Mailing Country'
  } else {
    return null
  }
})
const serviceProviderValid = computed(() => {
  if (!storeVar.value.serviceProvider) {
    return 'Enter Service Provider'
  } else {
    return null
  }
})
const fileNoValid = computed(() => {
  if (!storeVar.value.fileNo) {
    return 'Enter File No'
  } else {
    return null
  }
})
const referenceNoValid = computed(() => {
  if (!storeVar.value.referenceNo) {
    return 'Enter Reference No'
  } else {
    return null
  }
})
const simNoValid = computed(() => {
  if (!storeVar.value.simNo) {
    return 'Enter Sim No'
  } else {
    return null
  }
})
const typeOfNetworkValid = computed(() => {
  if (!storeVar.value.typeOfNetwork) {
    return 'Enter Type Of Network'
  } else {
    return null
  }
})
const cellModelNoValid = computed(() => {
  if (!storeVar.value.cellModelNo) {
    return 'Enter Cell Model No'
  } else {
    return null
  }
})
const imei1Valid = computed(() => {
  if (!storeVar.value.imei1) {
    return 'Enter IMEI 1'
  } else {
    return null
  }
})
const imei2Valid = computed(() => {
  if (!storeVar.value.imei2) {
    return 'Enter IMEI 2'
  } else {
    return null
  }
})
const typeOfPlanValid = computed(() => {
  if (!storeVar.value.typeOfPlan) {
    return 'Enter Type Of Plan'
  } else {
    return null
  }
})
const creditCardTypeValid = computed(() => {
  if (!storeVar.value.creditCardType) {
    return 'Enter Credit Card Type'
  } else {
    return null
  }
})
const contractValueValid = computed(() => {
  if (!storeVar.value.contractValue) {
    return 'Enter Contract Value'
  } else {
    return null
  }
})
const dateOfIssueValid = computed(() => {
  if (!storeVar.value.dateOfIssue) {
    return 'Enter Date Of Issue'
  } else {
    return null
  }
})
const dateOfRenewalValid = computed(() => {
  if (!storeVar.value.dateOfRenewal) {
    return 'Enter Date Of Renewal'
  } else {
    return null
  }
})
const installmentValid = computed(() => {
  if (!storeVar.value.installment) {
    return 'Enter Installment'
  } else {
    return null
  }
})
const amountInWordsValid = computed(() => {
  if (!storeVar.value.amountInWords) {
    return 'Enter Amount In Words'
  } else {
    return null
  }
})
const AllCollectionUserProject = computed(() => {
  if (storeVar.value.imageName) {
    // getAllCollectionUserProject(storeVar.value.imageName)
    return null
  } else {
    return null
  }
})


function onBack() {
  router.push('/project/all')
}
function disable(e) {
  e.preventDefault();
}
function onDrop(e){
  e.preventDefault();
}
function handleDragStart(e){
  e.preventDefault();
}
function disableTab(e) {
  if (e.keyCode === 9) {
    focus();
    e.preventDefault();
  }
}
function isNumberAndSpecial(e) {
  let char = String.fromCharCode(e.keyCode);
  if (/[0-9-/`~!#*$@_%+=.,'"^&(){}[\]|;:<>?\\]/g.test(char)) return true;
  else e.preventDefault();
}
function isNumber(e) {
  let char = String.fromCharCode(e.keyCode);
  if (/^[0-9]+$/.test(char)) return true;
  else e.preventDefault();
}
function isNumberWithHighpen(e) {
  let char = String.fromCharCode(e.keyCode);
  if (/^[0-9-]+$/.test(char)) return true;
  else e.preventDefault();
}

</script>
  